import * as tslib_1 from "tslib";
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { AuthenticationService } from '../services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/authentication.service";
import * as i2 from "@ngxs/store";
var AuthenticationGuard = /** @class */ (function () {
    function AuthenticationGuard(authenticationService, store) {
        this.authenticationService = authenticationService;
        this.store = store;
    }
    AuthenticationGuard.prototype.canActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authenticationService.isAuthenticated())
                            return [2 /*return*/, true];
                        if (!window.location.hash) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.authenticationService.handleAuthentication()];
                    case 2:
                        _a.sent();
                        this.store.dispatch(new Navigate([this.authenticationService.callbackPath || '/']));
                        this.authenticationService.callbackPath = null;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('handleAuthentication error', error_1);
                        this.authenticationService.login();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                    case 5:
                        this.authenticationService.login();
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AuthenticationGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.Store)); }, token: AuthenticationGuard, providedIn: "root" });
    return AuthenticationGuard;
}());
export { AuthenticationGuard };
